import { render, staticRenderFns } from "./PidDashQuickActions.vue?vue&type=template&id=04af74c6&scoped=true&"
import script from "./PidDashQuickActions.vue?vue&type=script&lang=js&"
export * from "./PidDashQuickActions.vue?vue&type=script&lang=js&"
import style0 from "./PidDashQuickActions.vue?vue&type=style&index=0&id=04af74c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af74c6",
  null
  
)

export default component.exports